import { render } from "./Modal.vue?vue&type=template&id=235bf2b4&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=235bf2b4&lang=scss&scoped=true"

import exportComponent from "D:\\srv\\vhost\\f-cat-app\\frontend\\musicbizz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235bf2b4"]])

export default __exports__